import { footerNavGroups } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">古古漫画网</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              古古漫画网追更连载实时更新，热门国漫日漫韩漫每日更新，免费全集下拉式阅读，人气漫画一网打尽。
            </p>
          </div>

          {footerNavGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-medium text-background-100 text-sm mb-4">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700">
          <div className="mb-6">
            <h4 className="font-medium text-background-200 text-sm mb-3">合作伙伴</h4>
            <p className="text-sm text-background-400">更多合作伙伴即将上线，敬请期待</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-400">
              &copy; {new Date().getFullYear()} 古古漫画网 - 追更连载，热门漫画每日更新，免费全集下拉式阅读
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">版权声明</a>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}